import actionTypes from "../../actions/actionTypes";

const _initState = {
  isLoading: false,
  data: 0,
};

const countNeprecitaneSpravy = (state = _initState, action) => {
  switch (action.type) {
    case actionTypes.GET_COUNT_NEPRECITANE_SPRAVY_REQUEST:
      return { ...state, isLoading: true };

    case actionTypes.GET_COUNT_NEPRECITANE_SPRAVY_SUCCESS:
      return { ...state, isLoading: false, data: action.res.Data };

    case actionTypes.GET_COUNT_NEPRECITANE_SPRAVY_FAILURE:
      return _initState;

    default:
      return state;
  }
};

export default countNeprecitaneSpravy;
